import _Object$getPrototypeOf from 'babel-runtime/core-js/object/get-prototype-of';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import React, { Component, cloneElement } from 'react';
import ReactDOM from 'react-dom';
import Button from '@atlaskit/button';
import ConfirmIcon from '@atlaskit/icon/glyph/check';
import CancelIcon from '@atlaskit/icon/glyph/cross';
import FieldBase, { Label } from '@atlaskit/field-base';

import RootWrapper from './styled/RootWrapper';
import ContentWrapper from './styled/ContentWrapper';
import ReadViewContentWrapper from './styled/ReadViewContentWrapper';
import FieldBaseWrapper from './styled/FieldBaseWrapper';
import ButtonsWrapper from './styled/ButtonsWrapper';
import ButtonWrapper from './styled/ButtonWrapper';
import EditButton from './styled/EditButton';

var DRAG_THRESHOLD = 5;

var InlineEdit = function (_Component) {
  _inherits(InlineEdit, _Component);

  function InlineEdit() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, InlineEdit);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = InlineEdit.__proto__ || _Object$getPrototypeOf(InlineEdit)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      fieldBaseWrapperIsHover: false,
      resetFieldBase: false,
      shouldResetFieldBase: false,
      wasFocusReceivedSinceLastBlur: false
    }, _this.onMouseDown = function (client) {
      return _this.setState({ startX: client.clientX, startY: client.clientY });
    }, _this.onWrapperClick = function (e) {
      if (!_this.isReadOnly() && !_this.props.isEditing && !_this.mouseHasMoved(e)) {
        _this.props.onEditRequested();
      } else {
        e.preventDefault();
        e.stopPropagation();
      }
      _this.setState({ startX: 0, startY: 0 });
    }, _this.onWrapperBlur = function () {
      if (_this.isReadOnly() || !_this.props.isEditing || _this.props.isConfirmOnBlurDisabled) {
        return;
      }

      _this.setState({ wasFocusReceivedSinceLastBlur: false });
      setTimeout(_this.confirmIfUnfocused, 10);
    }, _this.onWrapperFocus = function () {
      _this.setState({ wasFocusReceivedSinceLastBlur: true });
    }, _this.onConfirmClick = function (event) {
      //$FlowFixMe because Flow cant be sure the node will be a HTMLElement
      ReactDOM.findDOMNode(_this.confirmButtonRef).focus(); //eslint-disable-line react/no-find-dom-node
      event.preventDefault();
      _this.props.onConfirm();
    }, _this.onCancelClick = function (event) {
      //$FlowFixMe because Flow cant be sure the node will be a HTMLElement
      ReactDOM.findDOMNode(_this.cancelButtonRef).focus(); // eslint-disable-line react/no-find-dom-node

      event.preventDefault();
      _this.props.onCancel();
    }, _this.onDialogClick = function (event) {
      event.stopPropagation();
    }, _this.onFieldBaseWrapperMouseEnter = function () {
      return _this.setState({ fieldBaseWrapperIsHover: true });
    }, _this.onFieldBaseWrapperMouseLeave = function () {
      return _this.setState({ fieldBaseWrapperIsHover: false });
    }, _this.mouseHasMoved = function (event) {
      var startX = _this.state.startX || 0;
      var startY = _this.state.startY || 0;

      return Math.abs(startX - event.clientX) >= DRAG_THRESHOLD || Math.abs(startY - event.clientY) >= DRAG_THRESHOLD;
    }, _this.confirmIfUnfocused = function () {
      if (!_this.state.wasFocusReceivedSinceLastBlur) {
        _this.props.onConfirm();
      }
    }, _this.isReadOnly = function () {
      return !_this.props.editView;
    }, _this.shouldShowEditView = function () {
      return _this.props.isEditing && !_this.isReadOnly();
    }, _this.shouldRenderEditIcon = function () {
      return !_this.isReadOnly() && !_this.props.isInvalid;
    }, _this.shouldRenderSpinner = function () {
      return _this.props.isWaiting && _this.props.isEditing;
    }, _this.wrapWithFieldBase = function (children) {
      var _this$props = _this.props,
          invalidMessage = _this$props.invalidMessage,
          isEditing = _this$props.isEditing,
          isFitContainerWidthReadView = _this$props.isFitContainerWidthReadView,
          isInvalid = _this$props.isInvalid;


      return React.createElement(
        FieldBase,
        {
          isInvalid: isInvalid,
          isFocused: _this.isReadOnly() ? false : undefined,
          isReadOnly: _this.isReadOnly(),
          isFitContainerWidthEnabled: isEditing || isFitContainerWidthReadView,
          appearance: isEditing ? 'standard' : 'subtle',
          isDisabled: _this.shouldRenderSpinner(),
          isLoading: _this.shouldRenderSpinner(),
          shouldReset: _this.state.shouldResetFieldBase,
          invalidMessage: invalidMessage,
          onDialogClick: _this.onDialogClick
        },
        children
      );
    }, _this.renderActionButtons = function () {
      return _this.props.isEditing && !_this.props.areActionButtonsHidden ? React.createElement(
        ButtonsWrapper,
        null,
        React.createElement(
          ButtonWrapper,
          null,
          React.createElement(Button, {
            iconBefore: React.createElement(ConfirmIcon, { label: 'confirm', size: 'small' }),
            onClick: _this.onConfirmClick,
            shouldFitContainer: true,
            ref: function ref(_ref2) {
              // $FlowFixMe TEMPORARY
              _this.confirmButtonRef = _ref2;
            }
          })
        ),
        React.createElement(
          ButtonWrapper,
          null,
          React.createElement(Button, {
            iconBefore: React.createElement(CancelIcon, { label: 'cancel', size: 'small' }),
            onClick: _this.onCancelClick,
            shouldFitContainer: true,
            ref: function ref(_ref3) {
              // $FlowFixMe TEMPORARY
              _this.cancelButtonRef = _ref3;
            }
          })
        )
      ) : null;
    }, _this.renderReadView = function () {
      return _this.wrapWithFieldBase(React.createElement(
        ReadViewContentWrapper,
        null,
        _this.props.readView,
        React.createElement(EditButton, {
          type: 'button',
          fieldBaseWrapperIsHover: _this.state.fieldBaseWrapperIsHover
        })
      ));
    }, _this.renderEditView = function () {
      var editView = _this.props.shouldConfirmOnEnter ? //$FlowFixMe - suppress errors because of issues with not being able to define iterable
      cloneElement(_this.props.editView, {
        onConfirm: _this.props.onConfirm
      }) : _this.props.editView;

      return _this.props.disableEditViewFieldBase ? editView : _this.wrapWithFieldBase(editView);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(InlineEdit, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setState({
        shouldResetFieldBase: this.props.isEditing && !nextProps.isEditing
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var showEditView = this.shouldShowEditView();
      var displayFullWidth = showEditView || this.props.isFitContainerWidthReadView;
      return React.createElement(
        RootWrapper,
        { isEditing: this.props.isEditing },
        React.createElement(
          'div',
          {
            style: {
              position: this.props.isLabelHidden ? 'absolute' : 'relative'
            }
          },
          React.createElement(Label, {
            appearance: 'inline-edit',
            label: this.props.label,
            isLabelHidden: this.props.isLabelHidden,
            htmlFor: this.isReadOnly() ? undefined : this.props.labelHtmlFor,
            onClick: this.onWrapperClick,
            onMouseDown: this.onMouseDown
          })
        ),
        React.createElement(
          ContentWrapper,
          {
            onBlur: this.onWrapperBlur,
            onFocus: this.onWrapperFocus
          },
          React.createElement(
            FieldBaseWrapper // eslint-disable-line jsx-a11y/no-static-element-interactions
            ,
            { onClick: this.onWrapperClick,
              onMouseEnter: this.onFieldBaseWrapperMouseEnter,
              onMouseLeave: this.onFieldBaseWrapperMouseLeave,
              onMouseDown: this.onMouseDown,
              displayFullWidth: displayFullWidth
            },
            showEditView ? this.renderEditView() : this.renderReadView()
          ),
          !this.shouldRenderSpinner() ? this.renderActionButtons() : null
        )
      );
    }
  }]);

  return InlineEdit;
}(Component);

InlineEdit.defaultProps = {
  areActionButtonsHidden: false,
  disableEditViewFieldBase: false,
  invalidMessage: '',
  isConfirmOnBlurDisabled: false,
  isInvalid: false,
  isLabelHidden: false,
  isWaiting: false,
  shouldConfirmOnEnter: false
};
export default InlineEdit;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@atlaskit/inline-edit/dist/esm/InlineEditStateless.js
// module id = 286
// module chunks = 0